import React, { Component } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { Row, Col, Form, FormControl, Button } from 'react-bootstrap'
import messagesApi from '../../api/messages.api'
import { toast } from 'react-toastify'
import { MessageTypes } from '../../common/enums'
import UsersApi from '../../api/users.api'
import Cookies from "js-cookie";
import { isValidMacedonianNumber } from "../../utils/numbers";

export default class TextOnly extends Component {
  constructor(props) {
    super(props)
    this.state = {
      remainingCharacters: 1000,
      remainingCharErr: null,
      tagLabelErr: null,
      selectedFile: null,
      numbersFileName: '',
      fileError: null,
      bulkOption: 0,
      isSuperAdmin: Cookies.get("isSuperAdmin") === "true",
      number: ""
    }
    this.SendBulk = this.SendBulk.bind(this)
    this.onChangeHandler = this.onChangeHandler.bind(this)
  }

  async SendBulk() {
    if (this.validateForm()) {
      await messagesApi.sendBulk({
        text: this.props.messageText,
        messageType: MessageTypes.TextOnly,
        fileName: this.state.numbersFileName,
        tagLbl: this.props.tagLabel,
        number: this.state.number
      })
      this.props.resetState()
      this.setState({
        remainingCharacters: 1000,
        remainingCharErr: null,
      })
      toast.success('Пораката беше испратена')
    }
  }
  validateForm() {
    let formValid = true

    if (this.props.messageText == '') {
      this.setState({ remainingCharErr: 'Ве молиме внесете текст' })
      formValid = false
    } else if (this.props.remainingCharacters < 0) {
      this.setState({
        remainingCharErr: 'Максимум број на дозволени карактери е 1000',
      })
      formValid = false
    }
    if (this.props.tagLabel == '') {
      this.setState({ tagLabelErr: 'Ве молиме внесете ознака за кампања' })
      formValid = false
    }
    if (this.state.isSuperAdmin && this.state.numbersFileName == '') {
      this.setState({ fileError: 'Ве молиме одберете датотека со броеви' })
      formValid = false
    }
    return formValid
  }

  async onChangeHandler(event) {
    try {
      const target = event.target.files[0].name.slice(
        ((event.target.files[0].name.lastIndexOf('.') - 1) >>> 0) + 2,
      )
      if (target.toLowerCase() == 'xlsx') {
        const data = new FormData()
        data.append('file', event.target.files[0])
        var response = await UsersApi.uploadNumbers(data)
        this.setState({ numbersFileName: response.data.filename, fileError: '' })
      } else {
        this.setState({
          fileError: 'Неправилен формат на фајл. Форматот мора да биде .xlsx',
        })
      }
    } catch (err) {
      console.log(err);
    }

  }

  render() {
    return (
      <Col>
        <Form>
          <Form.Group as={Row}>
            <Col sm="10">
              <Col md={12}>
                <Form.Label column sm="6" className="heading bold-text">
                  Внесете текст
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows="10"
                  name="messageText"
                  onChange={this.props.handleChange}
                  className="text-area"
                  value={this.props.messageText}
                />
                <Col md={12} className="mt-4">
                  <Row>
                    <Col md={6}>
                      <p className="error">{this.state.remainingCharErr}</p>
                    </Col>
                    <Col md={6}>
                      <label
                        className="col-md-12 mt-2 pull-right"
                        style={{ textAlign: 'right' }}
                      >
                        Преостанати карактери {this.props.remainingCharacters}
                      </label>
                    </Col>
                  </Row>
                </Col>
              </Col>
              <Col xs={12} md={6} className="mt-4">
                <label className="bold-text">Ознака на кампања</label>
                <FormControl
                  type="text"
                  placeholder="Внесете ознака на кампањата"
                  onChange={this.props.handleChange}
                  name="tagLabel"
                  value={this.props.tagLabel}
                ></FormControl>
                <p className="error">{this.state.tagLabelErr}</p>
              </Col>
              <Col xs={12} md={6} className="mt-4">
                <label className="col-md-12 pl-0 bold-text">
                  {this.state.isSuperAdmin ? "Одберeте датотека со броеви" : "Внесете броj"}
                </label>
                {this.state.isSuperAdmin ? (
                  <input
                    type="file"
                    name="numbersFileName"
                    onChange={this.onChangeHandler}
                    value={this.state.selectedFile}
                  />
                ) : (
                  <FormControl
                    type="text"
                    placeholder="Внесете број во формат 3897xxxxxxx"
                    name="number"
                    value={this.state.number}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (isValidMacedonianNumber(value) || value === "") {
                        this.setState({ number: value, fileError: "" });
                      } else {
                        this.setState({ number: value, fileError: "Бројот мора да почнува со 3897 и да има вкупно 12 цифри." });
                      }
                    }}
                    maxLength={12}
                  />
                )}
                <p className="error">{this.state.fileError}</p>
              </Col>
              <Col xs={12} md={6} className="mt-4">
                <Button
                  onClick={this.SendBulk}
                  sm="3"
                  size="sm"
                  className="margin-top-10px button-standard"
                >
                  Испрати
                </Button>
              </Col>
            </Col>
          </Form.Group>
          <Form.Group as={Row}></Form.Group>
        </Form>
      </Col>
    )
  }
}
